import React from 'react'
import Card from '@mui/material/Card';
import { useState } from 'react';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';  //depracated must go to v2
import JourneySuggestion from '../JourneySuggestion';
import { useData } from '../DataProviderContext';
import { CardActionArea } from '@mui/material';
import { Alert, Box, ButtonBase, Chip, CircularProgress, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Tooltip, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import EditOutlined from '@mui/icons-material/EditOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ACTION_WRITING_GUIDANCE, LONG_ACTION_GUIDANCE, isLongAction } from '../actionTextGuidance';
import { LockedIconButton } from '../SignedInLock';

// 
const TOUCH_TARGET_SX = { minWidth: 44, minHeight: 44 };

// hmm i was thinking this was not top level yet I put a plus which makes it top level
// let just make it multi purpose
const getActionMarkerStyles = (action) => {
    if (action?.status === 'completed') {
        return { color: '#2e7d32', borderColor: '#2e7d32' };
    }

    if (action?.status === 'abandoned' || action?.status === 'deferred' || action?.relevance === 'irrelevant') {
        return { color: 'grey.600', borderColor: 'grey.500' };
    }

    if (action?.status === 'active' && action?.relevance === 'relevant') {
        return { color: '#b7791f', borderColor: '#f9c74f' };
    }

    return { color: 'primary.main', borderColor: 'primary.main' };
};

function JourneyCard({ stepId, content, cardOnly, cardKey, enableSave = false, index , listroot, objective, action}) {
    const { dataState, dispatch, toggleActionItemStatus } = useData();
    const [open, setOpen] = useState(false);
    const [actionText, setActionText] = useState(content || '');
    const [isContentExpanded, setIsContentExpanded] = useState(false);
    const [isCompletionSaving, setIsCompletionSaving] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isCompleted = action?.status === 'completed';
    const isGuestPreview = dataState.guestJourneyStatus === 'preview';


    const moveItem = (direction) => {
        // do dispatch
        // reorder list 
        // index + direction 
        dispatch({ type: 'REORDER_TASK', payload: { listroot:listroot, itemroot: stepId, direction: direction } });
    };

    const handleClickDelete = () => {
        //     console.log('DELETE THIS THING');
        //     console.log('cardKEy is ' + cardKey);
        dispatch({ type: 'REMOVE_SUGGESTION', payload: { keyId: cardKey, step_Id: listroot } });

    };

    const handleEdit = () => {
        setActionText(content || '');
        setOpen(true);
        //     console.log('DELETE THIS THING');
        //     console.log('cardKEy is ' + cardKey);
        //   removeClientSideItem({ keyId: cardKey });



    };

    const handleContentKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            if (isGuestPreview) setIsContentExpanded(true);
            else handleEdit();
        } else if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            setIsContentExpanded(false);
        }
    };

    const handleContentTouchEnd = (event) => {
        event.stopPropagation();
        setIsContentExpanded((current) => !current);
    };

    const handleToggleCompletion = async (event) => {
        event.stopPropagation();

        if (isCompletionSaving || !toggleActionItemStatus) {
            return;
        }

        setIsCompletionSaving(true);
        try {
            await toggleActionItemStatus({ listroot, actionItem: action });
        } finally {
            setIsCompletionSaving(false);
        }
    };




    const handleClose = () => {
        setOpen(false);
    };


    return (
        <Box sx={{ width: '100%', minWidth: 0 }}>
            <Card
                sx={{
                    width: '100%',
                    minWidth: 0,
                    borderRadius: 2,
                    boxShadow: 0,
                    borderColor: 'divider',
                    bgcolor: 'grey.50',
                    transition: (currentTheme) => currentTheme.transitions.create(['border-color', 'background-color']),
                    '&:hover': {
                        borderColor: 'primary.light',
                        bgcolor: 'background.paper',
                    },
                }}
                variant="outlined"
                data-testid="journey-action-card"
            >
                <CardActionArea component="div" onClick={() => dispatch({ type: 'SELECT_ITEM', payload: { card: cardKey, text: content } })}
                    data-active={cardKey === dataState.selectedNode ? '' : undefined}
                    data-testid="select-action"
                    sx={{
                        height: '100%',
                        '&[data-active]': {
                            backgroundColor: 'action.selected',
                            '&:hover': {
                                backgroundColor: 'action.selectedHover',
                            },
                        },
                    }}>
                    <CardContent sx={{ p: { xs: 1.75, sm: 2 }, '&:last-child': { pb: { xs: 1.75, sm: 2 } } }}>
                    {/* <Typography variant="h5" component="div">
                    STep ID  {stepId } : INDEX {index} : LISTroot {listroot}
                </Typography> */}
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                        <Chip
                            size="small"
                            label={`Action ${stepId + 1}`}
                            variant="outlined"
                            sx={{ fontWeight: 700, ...getActionMarkerStyles(action) }}
                        />
                    <Box>
                        {isGuestPreview ? <LockedIconButton label="Action status and ordering controls" sx={TOUCH_TARGET_SX} /> : null}
                        <Tooltip title={isCompleted ? 'Completed — click to reopen' : 'Mark as complete'}>
                            <span>
                                <IconButton
                                    onClick={handleToggleCompletion}
                                    disabled={isCompletionSaving || isGuestPreview}
                                    aria-label={isCompleted ? 'Reopen action' : 'Mark action as complete'}
                                    data-testid="toggle-action-completion"
                                    size="small"
                                    color={isCompleted ? 'success' : 'default'}
                                    sx={TOUCH_TARGET_SX}
                                >
                                    {isCompletionSaving ? (
                                        <CircularProgress size={20} />
                                    ) : isCompleted ? (
                                        <CheckCircleIcon data-testid="action-completed-icon" />
                                    ) : (
                                        <CheckCircleOutlineIcon data-testid="action-active-icon" />
                                    )}
                                </IconButton>
                            </span>
                        </Tooltip>
                        <IconButton
                            onClick={() => moveItem(-1)}
                            disabled={isGuestPreview || stepId === 0}
                            aria-label="Move action up"
                            data-testid="move-action-up"
                            size="small"
                            sx={TOUCH_TARGET_SX}
                        >
                            <ArrowUpward />
                        </IconButton>
                        <IconButton
                            onClick={() => moveItem( 1)}
                            disabled={isGuestPreview || stepId === dataState.userDocs.steps[listroot].items.length - 1}
                            aria-label="Move action down"
                            data-testid="move-action-down"
                            size="small"
                            sx={TOUCH_TARGET_SX}
                        >
                            <ArrowDownward />
                        </IconButton>
                    </Box>
                    </Box>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Stack direction="column" spacing={2}>
                                    {cardOnly ? null : <Typography variant="h4" component="div">CARD STEP Step {dataState.selectedNode}</Typography>}
                                    {cardOnly ? null : <JourneySuggestion selectedStep={dataState.selectedNode} />}
                                    {cardOnly ? (
                                        <ButtonBase
                                            data-testid="action-content"
                                            aria-label="View full action text. Press Enter to edit."
                                            aria-expanded={isContentExpanded}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                if (!isMobile) setIsContentExpanded(true);
                                            }}
                                            onDoubleClick={(event) => {
                                                event.stopPropagation();
                                                setIsContentExpanded(false);
                                            }}
                                            onTouchEnd={handleContentTouchEnd}
                                            onKeyDown={handleContentKeyDown}
                                            sx={{
                                                display: isContentExpanded ? 'block' : '-webkit-box',
                                                WebkitLineClamp: isContentExpanded ? 'unset' : 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: isContentExpanded ? 'visible' : 'hidden',
                                                textOverflow: isContentExpanded ? 'clip' : 'ellipsis',
                                                wordBreak: 'break-word',
                                                overflowWrap: 'anywhere',
                                                minHeight: '3.2em',
                                                width: '100%',
                                                justifyContent: 'flex-start',
                                                textAlign: 'left',
                                                whiteSpace: isContentExpanded ? 'pre-wrap' : 'normal',
                                                touchAction: 'manipulation',
                                                typography: 'body1',
                                                fontWeight: 600,
                                                color: isCompleted ? 'text.secondary' : 'text.primary',
                                                lineHeight: 1.6,
                                                opacity: isCompleted ? 0.78 : 1,
                                                textDecoration: isCompleted ? 'line-through' : 'none',
                                            }}
                                        >
                                            {content}
                                        </ButtonBase>
                                    ) : null}
                                    <Stack direction="row" spacing={1} sx={{ pt: 0.5, justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap', rowGap: 1 }}>
                                        {isGuestPreview ? <LockedIconButton label="Action editing controls" sx={TOUCH_TARGET_SX} /> : null}
                                        <IconButton
                                            color="primary"
                                            onClick={(handleEdit)}
                                            data-testid="edit-action"
                                            aria-label="Edit action"
                                            disabled={isGuestPreview}
                                            sx={TOUCH_TARGET_SX}
                                        >
                                            <EditOutlined />
                                        </IconButton>
                                        <IconButton
                                            color="error"
                                            onClick={(handleClickDelete)}
                                            data-testid="delete-action"
                                            aria-label="Delete action"
                                            disabled={isGuestPreview}
                                            sx={TOUCH_TARGET_SX}
                                        >
                                            <DeleteOutline />
                                        </IconButton>
                                    </Stack>

                                </Stack>


                            </Grid>
                        </Grid>

                    </CardContent>
                </CardActionArea>
            </Card>


            {/* Dialog component */}
            <Dialog open={open} onClose={handleClose}
                fullScreen={isMobile}
                fullWidth
                maxWidth={'md'}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        // invoke firebase here?
                        // put in Quuee to submit
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries(formData.entries());
                        const suggestion = formJson.suggestion;
                        console.log(suggestion);
                        dispatch({ type: 'EDIT_ITEM', payload: {step_Id: listroot, target: cardKey, value: suggestion } });

                        //updateClientSideJourney(selectedStep, suggestion);
                        handleClose();
                    },
                }}>
                                    {cardOnly ? null : <Typography variant="h4" component="div">CARD STEP Step {dataState.selectedNode}</Typography>}   


                <Box
                    data-testid="edit-action-content-column"
                    sx={{ width: '100%', maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 4, md: 6 }, boxSizing: 'border-box' }}
                >
                    <DialogTitle sx={{ px: 0 }}>{objective?.text || 'Edit action'}</DialogTitle>
                    <DialogContent sx={{ px: 0, pt: 0 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Update the action that helps move this step forward. {objective?.description || ''}
                        </Typography>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="name"
                            name="suggestion"
                            data-testid="action-input"
                            label="Action"
                            type="text"
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            value={actionText}
                            onChange={(event) => setActionText(event.target.value)}
                            helperText={ACTION_WRITING_GUIDANCE}
                        />
                        {isLongAction(actionText) ? (
                            <Alert severity="info" variant="outlined" data-testid="long-action-guidance" sx={{ mt: 1 }}>
                                {LONG_ACTION_GUIDANCE}
                            </Alert>
                        ) : null}
                    </DialogContent>
                    <DialogActions sx={{ px: 0 }}>
                        <Button type="submit" data-testid="save-action">Save</Button>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </Box>
    );
}
export default JourneyCard;
